// GeoJson specification
export interface IGeometry {
  type: string;
  coordinates: number[];
}

export interface IGeoJson {
  type: string;
  geometry: IGeometry;
  properties?: any;
}

export class GeoJson implements IGeoJson {
  type = 'Feature';
  geometry: IGeometry;

  constructor(coordinates, public properties?) {
    this.geometry = {
      type: 'MultiPoint',
      coordinates: coordinates
    };
  }
}

// Mapbox specification
export interface IMapboxSource {
  type: string;
  data: GeoJson;
}

export interface IMapboxLayer {
  id: string;
  type: string;
  source: IMapboxSource;
  paint: Object;
}

export class MapboxLayer implements IMapboxLayer {
  type = 'circle';
  pathFragment: string;
  source: IMapboxSource;
  paint = {
    'circle-radius': {
      'base': 1.75,
      'stops': [[5, 2], [12, 10]]
    }
  };

  constructor(public id: string, geoJson: GeoJson, color: string, pathFragment: string) {
    this.source = {
      type: 'geojson',
      data: geoJson
    };
    this.paint['circle-color'] = color;
    this.pathFragment = pathFragment;
  }
}

export class MapLayerRequest {
  name: string;
  year: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// /app/src/app/map.ts